import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import useStores from 'hooks/use-stores';
import Footer from 'main/components/Footer';
import LoginNotification from 'pages/components/LoginNotification';
import useIsMobile from 'pages/landing/v2/Main/hooks/use-is-mobile';
import isEmpty from 'utils/is-empty';

import Content from './components/Content';
import HistoryOfChangesProvider from './components/HistoryOfChangesProvider';
import PrivateArea from './components/Private';
import Related from './components/Related';
import RelatedBox from './components/RelatedBox';
import Score from './components/Score';
import useStyles from './styles';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    references: any;
}

const Item: React.FC<Props> = ({ data, references }) => {
    const { classes } = useStyles();
    const { naslStore } = useStores();
    const isMobile = useIsMobile();

    useEffect(() => {
        if (isEmpty(naslStore.naslTypes)) {
            naslStore.loadTypes();
        }
    }, [naslStore]);

    if (!data) {
        return null;
    }

    const aiScore = data.enchantments?.score;
    const { metrics, cna_cvss, epss, id, type, privateArea } = data;

    return (
        <HistoryOfChangesProvider id={id}>
            <div className={classes.item}>
                <div className={classes.contentWrapper}>
                    <div className={classes.content}>
                        <Content data={data} />
                    </div>

                    {privateArea ? (
                        <div className={classes.privateArea}>
                            <PrivateArea bulletinType={type} privateArea={privateArea} />
                        </div>
                    ) : null}

                    {isEmpty(references) ? null : (
                        <div className={classes.related}>
                            <Related references={references} />
                        </div>
                    )}

                    <Footer />
                </div>
                {!isMobile && (
                    <div className={classes.score}>
                        <Score aiScore={aiScore} metrics={metrics} epss={epss} cnaCvss={cna_cvss} id={id} />
                        {isEmpty(references) ? null : <RelatedBox cveId={id} references={references} />}
                    </div>
                )}
            </div>
            <LoginNotification />
        </HistoryOfChangesProvider>
    );
};

export default observer(Item);
